import { lightColors } from '@/plugins/colors/base/baseColorsLight'
import buttonTokensLight from '@/plugins/colors/tokens/light/sections/button'

const tabTokensLight = {
  'tab-nav-foreground-default': lightColors.gray['900'],
  'tab-nav-foreground-hover': lightColors.brand['500'],
  'tab-nav-foreground-active': lightColors.brand['500'],
  'tab-nav-foreground-disabled': lightColors.gray['400'],
  'tab-nav-border-default': lightColors.gray['900'],
  'tab-nav-border-hover': lightColors.brand['500'],
  'tab-nav-border-active': lightColors.brand['500'],
  'tab-nav-border-disabled': lightColors.gray['400'],
  'tab-background-default': lightColors.gray['50'],
  'tab-background-hover': lightColors.gray['100'],
  'tab-background-active': lightColors.gray.white,
  'tab-background-disabled':
    buttonTokensLight['button-secondary-gray-background-disabled'],
  'tab-border-active': lightColors.brand['700'],
  'tab-foreground-default': lightColors.gray['900'],
  'tab-foreground-hover': lightColors.gray['900'],
  'tab-foreground-active': lightColors.gray['900'],
  'tab-foreground-disabled':
    buttonTokensLight['button-secondary-gray-foreground-disabled']
}

export default tabTokensLight
